/**
 * CountryFlag Component
 * Renders an SVG country flag using country-flag-icons package.
 * Uses inline SVG strings for crisp rendering at any size.
 */

import * as flags from 'country-flag-icons/string/3x2';

const FLAG_SVGS = flags as Record<string, string>;

interface CountryFlagProps {
  country: string;
  className?: string;
}

/**
 * Strip fixed width/height from SVG string so it scales to container.
 * Keeps viewBox for proper aspect ratio.
 */
function scaleSvg(raw: string): string {
  return raw
    .replace(/\s+width="[^"]*"/, '')
    .replace(/\s+height="[^"]*"/, '')
    .replace('<svg', '<svg width="100%" height="100%"');
}

export const CountryFlag = ({ country, className = 'h-4 w-6' }: CountryFlagProps) => {
  const svg = FLAG_SVGS[country];
  if (!svg) return <span className={className}>{country}</span>;

  return (
    <span
      className={`inline-block overflow-hidden rounded-sm ${className}`}
      dangerouslySetInnerHTML={{ __html: scaleSvg(svg) }}
      aria-hidden="true"
    />
  );
};
